import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import navimg from '../assets/navimg.png';
import { GiHamburgerMenu } from 'react-icons/gi';
import HumseJudeImg from '../assets/HumseJudeImg.png';
import missionImage1 from '../assets/missionImage1.png';

const HumseJude = () => {
  const [isOpen, setIsOpen] = useState(false);

  const cards = [
    {
      title: "समर्थकों को जोड़ने हेतु जुड़ें",
      path: "/samarthak"
    },
    {
      title: "रोटी बेटी का रिश्ता बनाने हेतु जुड़ें",
      path: "/rotibeti"
    },
    {
      title: "सामाजिक समरस पर्यटन को बढ़ावा देने हेतु जुड़ें",
      path: "/humse3"
    },
    {
      title: "कन्यादान करने हेतु जुड़े",
      path: "/kanyadan"
    }
  ];

  return (
    <div className="relative h-screen w-full overflow-hidden bg-[rgba(175,160,60,0.28)]">
      {/* Navbar */}
      <nav className="absolute top-2 left-0 right-0 h-[60px] bg-white z-20 shadow-md flex justify-between items-center px-4 mx-auto w-full">
        {/* Left side of the navbar */}
        <div className="flex items-center gap-2">
          <img
            src={navimg}
            alt="Logo for the family reservation initiative"
            className="w-[55px] h-[30px] sm:w-[70px] sm:h-[40px] md:w-[90px] md:h-[50px]"
          />
          <h1
            className="font-UnifrakturCook font-bold text-[#B50301]"
            style={{
              fontSize: 'clamp(0.9rem, 2vw + 0.9rem, 1.8rem)',
              lineHeight: 'clamp(1.1rem, 2.3vw + 1.1rem, 3.2rem)',
              maxWidth: 'clamp(60%, 80%, 100%)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            एक परिवार, एक आरक्षण
          </h1>
        </div>

        {/* Toggle Button for Medium and Small Screens Only */}
        <button
          className="lg:hidden text-xl sm:text-2xl text-[#EA772A] focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          <GiHamburgerMenu />
        </button>

        {/* Navbar Links (Dropdown for Medium and Smaller Screens, Inline for Larger Screens) */}
        <div
          className={`lg:flex lg:items-center ${
            isOpen ? 'block' : 'hidden'
          } absolute lg:relative top-[60px] lg:top-auto left-0 w-full lg:w-auto bg-white lg:bg-transparent shadow-md lg:shadow-none z-10`}
        >
          <div className="flex sm:flex-col lg:flex-row items-center gap-2 lg:gap-4 py-4 lg:py-0 px-4 lg:px-0">
            <RouterLink
              to="/"
              className="text-[#B50301] cursor-pointer hover:scale-105 duration-200 hover:text-orange-700 text-xs sm:text-sm md:text-base font-extrabold"
            >
              Home
            </RouterLink>
            <RouterLink
              to="/"
              className="text-[#B50301] cursor-pointer hover:scale-105 duration-200 hover:text-orange-700 text-xs sm:text-sm md:text-base font-extrabold"
            >
              अभियान के बारे में
            </RouterLink>
            <RouterLink
              to="/"
              className="text-[#B50301] cursor-pointer hover:scale-105 duration-200 hover:text-orange-700 text-xs sm:text-sm md:text-base font-extrabold"
            >
              अभियान के सूत्रधार
            </RouterLink>
            <RouterLink
              to="/"
              className="text-[#B50301] cursor-pointer hover:scale-105 duration-200 hover:text-orange-700 text-xs sm:text-sm md:text-base font-extrabold"
            >
              सामान्यतः पूछे जाने वाले प्रश्न
            </RouterLink>
            <RouterLink
              to="/"
              className="text-[#B50301] cursor-pointer hover:scale-105 duration-200 hover:text-orange-700 text-xs sm:text-sm md:text-base font-extrabold"
            >
              हमसे जुडें
            </RouterLink>

            {/* Button to navigate to Video Upload */}
            <RouterLink to="/">
              <button className="bg-[#B50301] text-white px-2 sm:px-3 md:px-4 py-1 sm:py-2 rounded hover:scale-105 duration-200 text-xs sm:text-sm md:text-base font-extrabold">
                आपका योगदान
              </button>
            </RouterLink>
          </div>
        </div>
      </nav>

      {/* Heading */}
      <div className="absolute top-[100px] w-full text-center">
        <h2 className="font-bold text-[#B50301] sm:text-2xl md:text-4xl lg:text-5xl">
          हमसे जुडें और अपना योगदान दें
        </h2>
      </div>

      {/* Cards Section - Updated */}
      <div className="absolute top-[170px] w-full flex justify-center gap-4 px-4 z-30">
        {cards.map((card, index) => (
          <div
            key={index}
            className="w-[20%] h-[200px] bg-cover bg-opacity-50 flex flex-col items-center justify-between p-4 rounded-lg shadow-md relative overflow-hidden"
            style={{ backgroundImage: `url(${missionImage1})` }}
          >
            {/* Dark overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg"></div>
            
            {/* Content container */}
            <div className="relative z-20 h-full flex flex-col items-center justify-between">
              <p className="text-white text-sm sm:text-lg md:text-2xl font-extrabold text-center flex-grow flex items-center justify-center">
                {card.title}
              </p>
              
              <RouterLink 
                to={card.path}
                className="mt-4 inline-block"
              >
                <button className="bg-white text-[#B50301] text-xs sm:text-sm md:text-lg px-3 sm:px-4 md:px-6 py-1 sm:py-2 md:py-3 rounded-lg hover:bg-[#B50301] hover:text-white transition-colors duration-300">
                  क्लिक करें
                </button>
              </RouterLink>
            </div>
          </div>
        ))}
      </div>

      {/* Image Section */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-[95%] h-[350px] overflow-hidden flex justify-center z-10">
        <img
          src={HumseJudeImg}
          alt="Humse Jude banner"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </div>
  );
};

export default HumseJude;